export default __webpack_public_path__ + "static/media/choice_correct.403f9f65.mp3";